import React from 'react'
import {
  styled,
  MenuItem,
  TextField,
  TextFieldProps,
  Box,
  Typography,
  useTheme,
} from '@mui/material'
import { useFormEditable } from '../../../providers'

const container = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}

const errorStyle = { fontSize: '14px' }

type Option = {
  // TODO: Type me
  value: any
  label: string
}

type CustomSelectProps = {
  readonly?: boolean
  options: Option[]
  errorMsg?: string
} & TextFieldProps

const StyledSelect = styled(TextField)(({ theme }) => ({
  '&.MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.grey[300],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.grey[400],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.grey[400],
      borderWidth: 1,
    },
  },
  '&.Mui-focused': {
    '&.MuiInputLabel-outlined': {
      color: '#2e2e2e',
      fontWeight: 'bold',
    },
  },
  '& .Mui-disabled': {
    WebkitTextFillColor: 'black',
    backgroundColor: 'whitesmoke',
  },
}))

export const Select = React.forwardRef<HTMLDivElement, CustomSelectProps>(
  (
    { options, readonly, disabled, placeholder, errorMsg, ...restProps },
    ref
  ) => {
    const theme = useTheme()
    const { isEditable } = useFormEditable()

    return (
      <Box sx={container}>
        <StyledSelect
          variant="outlined"
          select
          placeholder={placeholder}
          {...restProps}
          disabled={readonly || !isEditable || disabled}
          slotProps={{
            input: {
              readOnly: readonly || !isEditable,
            },
          }}
        >
          {options?.map(({ value, label }) => (
            <MenuItem key={`${value}-${label}`} value={value}>
              {label}
            </MenuItem>
          ))}
        </StyledSelect>

        {errorMsg && (
          <Typography sx={errorStyle} color={theme?.palette?.error?.main}>
            {errorMsg}
          </Typography>
        )}
      </Box>
    )
  }
)
